import React from 'react';
import Link from 'next/link';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export default function Logo({ size = 'md', className = '' }: LogoProps) {
  const sizes = {
    sm: { icon: 28, text: 'text-base' },
    md: { icon: 36, text: 'text-lg' },
    lg: { icon: 44, text: 'text-xl' },
  };

  const { icon, text } = sizes[size];

  return (
    <Link href="/" className={`flex items-center gap-2.5 group ${className}`} aria-label="Forum Technical Solutions - Home">
      <div
        className="relative flex items-center justify-center rounded-lg flex-shrink-0"
        style={{ width: icon, height: icon, backgroundColor: 'var(--brand)', padding: '5px' }}
      >
        <svg viewBox="0 0 24 24" fill="none" className="w-full h-full" aria-hidden="true">
          <path
            d="M12 3L4 7V12C4 16.4 7.4 20.5 12 21.5C16.6 20.5 20 16.4 20 12V7L12 3Z"
            fill="#0B0D0F"
            stroke="#0B0D0F"
            strokeWidth="0.5"
          />
          <path
            d="M9 12L11 14L15 10"
            stroke="var(--brand)"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8 7.5H10M14 7.5H16M12 7.5V9.5"
            stroke="#0B0D0F"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </svg>
      </div>
      <div className="flex flex-col leading-none">
        <span className={`font-bold tracking-tight text-foreground ${text}`} style={{ letterSpacing: '-0.02em' }}>
          FORUM
        </span>
        <span className="text-xs font-medium tracking-widest uppercase" style={{ color: 'var(--text-muted)', fontSize: '9px', letterSpacing: '0.15em' }}>
          Technical Solutions
        </span>
      </div>
    </Link>
  );
}